const getUrl = ()=>{
	const hostArr = window.location.hostname.split('.')
	let str = 'https://'
	hostArr.forEach((host,k) => {
			if ( k === 0 ) {
					str += `api`
			}else{
					str += `.${host}`
			}

	})
  console.log(str)
	return str
}
const config = {
    server: getUrl(),
    // server: 'https://api.premiumwildginseng.com',
    imgBase: 'https://pub-c2389420f00f41608b1c7310a25383bd.r2.dev',
    name:"Global",
	tokenKey: 'd-token',
	userInfoKey: 'd-userInfo'
}
export default config
